import { render, staticRenderFns } from "./AutovistoriaVeiculoForm.vue?vue&type=template&id=33413854"
import script from "./AutovistoriaVeiculoForm.vue?vue&type=script&lang=js"
export * from "./AutovistoriaVeiculoForm.vue?vue&type=script&lang=js"
import style0 from "./AutovistoriaVeiculoForm.vue?vue&type=style&index=0&id=33413854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports